import { ProductDetails } from '@/modals/product-details';
import { RegistrationDetails } from '@/models/login/registrationDetails';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppService } from '@services/app.service';
import { ConfigService } from '@services/config.service';
import { error } from 'console';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrl: './user-profile.component.scss'
})
export class UserProfileComponent implements OnInit {
    destroy$: Subject<boolean> = new Subject<boolean>();
    user:RegistrationDetails;
    model:boolean=false;
    updateError:boolean = false
    adminWhatsAppNumber: string  = '';

constructor(
      private router: Router,
      private config: ConfigService,
      private appService: AppService,
      private spinner: NgxSpinnerService
){}

ngOnInit(): void {
    this.getAllProducts()
}

    
      getAllProducts() {
        this.spinner.show();
        this.appService.getUserDetails()
          .pipe(takeUntil(this.destroy$))
          .subscribe((data: RegistrationDetails) => {
            this.spinner.hide();
            this.user = data
            this.adminWhatsAppNumber = this.user.whatsappNumber
            console.log("userDetails", this.user);
          }, (error: any) => {
             this.spinner.hide();
            console.error("Something Went Wrong", error);
          })
      }


      openModel(){
        this.model = !this.model
      }
    
whatsAppNumber() {
    const phone = this.adminWhatsAppNumber;
  if (phone.length == 12 ) {
    this.updateError = false;
    const requestBody = {
       userRegistrationId:this.user.userRegistrationId,
        name: this.user.name,
        emailId: this.user.emailId,
        phoneNumber:this.user.phoneNumber,
        userType: this.user.userType,
        countryCode: this.user.countryCode,
        createdBy:this.user.createdBy,
        createdAt:this.user.createdAt,
        updateAt: this.user.updateAt,
        userAddress: this.user.userAddress,
        whatsappNumber: this.adminWhatsAppNumber,
        haveWhatsapp:true
    };
    console.log("WhatsApp number updated:", phone);
    console.log("Request Body:", requestBody);
    this.updateWhatsAppNumber(requestBody)

  } else {
    this.updateError = true;
  }
}



updateWhatsAppNumber(requestBody){
    this.spinner.show()
    this.appService.updateWhatsAppNumber(requestBody)
    .pipe(takeUntil(this.destroy$))
    .subscribe((data)=>{
          this.spinner.hide()
          this.model = false
          this.getAllProducts()
      console.log("dddddd", data)
    },(error:any)=>{
      this.spinner.hide();
      console.error("Something Went Wrong", error);
    })
}
    

}
